import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatOptionModule } from '@angular/material/core';
import { AppMaterialModule } from 'src/app/app-material.module';
import { BehaviorSubject, map, startWith } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import {
  isValidResult,
  IncumbentCriteriaResult,
  RequestTargetSearchComponent,
  IncumbentDropdownOptions,
} from '../request-target-search/request-target-search.component';

@Component({
  selector: 'app-conversion-selection-dialog',
  templateUrl: './conversion-selection-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    AppMaterialModule,
    MatOptionModule,
    ReactiveFormsModule,
    RequestTargetSearchComponent,
  ],
  styleUrls: ['./conversion-selection-dialog.component.scss'],
})
export class ConversionSelectionDialogComponent {
  protected readonly IncumbentDropdownOptions = IncumbentDropdownOptions;

  protected selectedOption = new BehaviorSubject<IncumbentCriteriaResult>(null);
  protected nextIsDisabled$ = this.selectedOption.pipe(
    map(r => !isValidResult(r)),
    startWith(true),
    distinctUntilChanged(),
  );

  selfDialogRef: MatDialogRef<
    ConversionSelectionDialogComponent,
    IncumbentCriteriaResult | null
  >;

  constructor(
    _selfDialogRef: MatDialogRef<ConversionSelectionDialogComponent>,
  ) {
    this.selfDialogRef = _selfDialogRef;
  }

  onSelectionChange(selection: IncumbentCriteriaResult | null) {
    this.selectedOption.next(selection);
  }

  closeModal() {
    this.selfDialogRef.close(null);
  }

  nextButtonClicked() {
    const resultType = this.selectedOption.value.resultType;
    const value = this.selectedOption.value.value;
    if (resultType === null || value === null) {
      this.selfDialogRef.close(null);
    } else {
      this.selfDialogRef.close({ resultType, value });
    }
  }
}
